import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { dataReducer } from './data.store'
import { appStateReducer } from './app.state.store'
import { appointmentReducer } from './appointment.store'

const reducer = combineReducers({
  data: dataReducer,
  appState: appStateReducer,
  appointment: appointmentReducer,
})

export const createAppStore = (preloadedState?: unknown) => configureStore({
  reducer,
  // State comes from the SSR render, so it already has the store's shape
  preloadedState: preloadedState as ReturnType<typeof reducer> | undefined,
  devTools: typeof window !== 'undefined',
})

const takePreloadedState = () => {
  if (typeof window === 'undefined') {
    return undefined
  }
  const state = window.__PRELOADED_STATE__
  delete window.__PRELOADED_STATE__
  return state
}

/** The browser store; the SSR server makes its own with createAppStore() per request */
export const store = createAppStore(takePreloadedState())

export type StoreType = ReturnType<typeof createAppStore>
export type RootState = ReturnType<StoreType['getState']>
export type AppDispatch = StoreType['dispatch']
